import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import {
  createMotorista,
  deleteMotorista,
  fetchMotoristas,
  updateMotorista,
} from "./api";
import { extractErrorMessage } from "../../shared/api/axios";

const QUERY_KEY = ["motoristas"];

export function useMotoristas() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchMotoristas,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: QUERY_KEY });
}

export function useCreateMotorista() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: createMotorista,
    onSuccess: () => {
      message.success("Motorista adicionado");
      invalidate();
    },
    onError: (err) => message.error(extractErrorMessage(err, "Erro ao adicionar motorista")),
  });
}

export function useUpdateMotorista() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: updateMotorista,
    onSuccess: () => {
      message.success("Motorista atualizado");
      invalidate();
    },
    onError: (err) => message.error(extractErrorMessage(err, "Erro ao atualizar motorista")),
  });
}

export function useDeleteMotorista() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: deleteMotorista,
    onSuccess: () => {
      message.success("Motorista excluido");
      invalidate();
    },
    onError: (err) => message.error(extractErrorMessage(err, "Erro ao excluir motorista")),
  });
}
